import { CheckCircleOutline, ErrorOutline } from '@mui/icons-material';
import {
  Box,
  CircularProgress,
  LinearProgress,
  Tooltip,
  Typography,
} from '@mui/material';
import React from 'react';
import { MemberCreationStatusItem } from './utils';

interface ActionLogPanelProps {
  errors: string[];
  status: MemberCreationStatusItem[];
  /** [current, total] tuple; empty until an action initializes it. */
  progress: number[];
}

export const ActionLogPanel: React.FC<ActionLogPanelProps> = ({
  errors,
  status,
  progress,
}) => (
  <>
    {errors.length > 0 && (
      <Box>
        {errors.map((error, i) => (
          // biome-ignore lint/suspicious/noArrayIndexKey: -
          <Typography key={error + i} color="error" fontSize="small">
            Error: {error}
          </Typography>
        ))}
        <Typography fontSize="small">
          An error occurred, refresh the page and try again. If the issue
          persists, please contact support.
        </Typography>
      </Box>
    )}
    {status.length > 0 && (
      <>
        <Box maxHeight="200px" overflow="auto">
          {progress.length > 0 && (
            <Typography>
              {progress[0]} / {progress[1]}
            </Typography>
          )}
          {status.map(({ id, label, status: itemStatus, message }) => (
            <Box
              key={id}
              display="flex"
              alignItems="center"
              justifyContent="start"
              gap={1}
            >
              <Typography> {label}</Typography>
              {
                {
                  loading: <CircularProgress size={14} />,
                  done: <CheckCircleOutline fontSize="small" color="success" />,
                  error: (
                    <Tooltip title={message}>
                      <ErrorOutline fontSize="small" color="error" />
                    </Tooltip>
                  ),
                }[itemStatus]
              }
            </Box>
          ))}
        </Box>
        {progress.length > 0 && (
          <LinearProgress
            variant="determinate"
            value={(progress[0] / progress[1]) * 100}
          />
        )}
      </>
    )}
  </>
);
